module.exports = __webpack_public_path__ + "img/dzpdf6.c294f3f8.png";